import { useEffect, useRef, useState } from "react";

export const useScroll = () => {
  const scrollContainerRef = useRef<HTMLDivElement | null>(null);
  const [isAtStart, setIsAtStart] = useState<boolean>(true);
  const [isAtEnd, setIsAtEnd] = useState<boolean>(false);

  const onHorizontalScroll = (direction: string) => {
    if (scrollContainerRef.current) {
      const scrollAmount = 200;
      const newScrollPosition = scrollContainerRef.current.scrollLeft +
        (direction === "left" ? -scrollAmount : scrollAmount);

      scrollContainerRef.current.scrollTo({
        left: newScrollPosition,
        behavior: "smooth",
      });
    }
  };

  const checkScrollAndHideButton = () => {
    const scrollContainer = scrollContainerRef.current;
    if (scrollContainer) {
      if (scrollContainer.scrollWidth === scrollContainer.clientWidth) {
        setIsAtEnd(true);
      }
    }
  };

  useEffect(() => {
    checkScrollAndHideButton();

    const handleScroll = () => {
      const scrollContainer = scrollContainerRef.current;
      if (scrollContainer) {
        const { scrollLeft, scrollWidth, clientWidth } = scrollContainer;
        if (scrollLeft === 0) {
          setIsAtStart(true);
          return;
        }
        if (scrollLeft + clientWidth + 1 >= scrollWidth) {
          setIsAtEnd(true);
          return;
        }
        setIsAtStart(false);
        setIsAtEnd(false);
      }
    };
    const scrollContainer = scrollContainerRef.current;
    if (scrollContainer) {
      scrollContainer.addEventListener("scroll", handleScroll);
    }
    return () => {
      if (scrollContainer) {
        scrollContainer.removeEventListener("scroll", handleScroll);
      }
    };
  });

  return {
    onHorizontalScroll,
    scrollContainerRef,
    isAtEnd,
    isAtStart,
  };
};
